import { PdTimeline } from "./pd-timeline/PdTimeline.js";
//#region src/pd-timeline/pd-timeline.ts
var tag = "pd-timeline";
if (!customElements.get(tag)) customElements.define(tag, PdTimeline);
//#endregion
export { PdTimeline };
